import { Divider } from '@xing-com/divider';

import { InsightWrapper, Icon, Text } from './insight.styles';

type Insight = {
  text: string;
};

export const Insight: React.FC<Insight> = ({ text }) => (
  <>
    <Divider />
    <InsightWrapper>
      <Icon height="48" width="48" />
      <Text size="large" noMargin>
        {text}
      </Text>
    </InsightWrapper>
  </>
);
